module.exports = __webpack_public_path__ + "media/images/icons/awards-77c462437a7f5605a1048c2efe79335e.svg";